var _circle, _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCtaRedemptionIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "url(#paint0_linear_13172_114765)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.25 43.6641C31.25 42.7213 31.25 42.2498 31.5429 41.957C31.8358 41.6641 32.3072 41.6641 33.25 41.6641H66.75C67.6928 41.6641 68.1642 41.6641 68.4571 41.957C68.75 42.2498 68.75 42.7213 68.75 43.6641V50.0807C68.75 51.0235 68.75 51.4949 68.4571 51.7878C68.1642 52.0807 67.6928 52.0807 66.75 52.0807H64.5C63.5572 52.0807 63.0858 52.0807 62.7929 52.3736C62.5 52.6665 62.5 53.1379 62.5 54.0807V64.6641C62.5 65.6069 62.5 66.0783 62.2071 66.3712C61.9142 66.6641 61.4428 66.6641 60.5 66.6641H39.5C38.5572 66.6641 38.0858 66.6641 37.7929 66.3712C37.5 66.0783 37.5 65.6069 37.5 64.6641V54.0807C37.5 53.1379 37.5 52.6665 37.2071 52.3736C36.9142 52.0807 36.4428 52.0807 35.5 52.0807H33.25C32.3072 52.0807 31.8358 52.0807 31.5429 51.7878C31.25 51.4949 31.25 51.0235 31.25 50.0807V43.6641Z",
    stroke: "#F2F2F2",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.417 52.0859H64.5837",
    stroke: "#F2F2F2",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50 39.5859L50 66.6693",
    stroke: "#F2F2F2",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0003 39.5833L46.6282 36.2112C45.4206 35.0037 43.9486 34.0939 42.3285 33.5538L40.6198 32.9843C38.0602 32.1311 35.417 34.0362 35.417 36.7343V36.7343C35.417 38.4357 36.5057 39.9462 38.1198 40.4843L41.667 41.6667",
    stroke: "#F2F2F2",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9997 39.5833L53.3718 36.2112C54.5794 35.0037 56.0514 34.0939 57.6715 33.5538L59.3802 32.9843C61.9397 32.1311 64.583 34.0362 64.583 36.7343V36.7343C64.583 38.4357 63.4943 39.9462 61.8802 40.4843L58.333 41.6667",
    stroke: "#F2F2F2",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13172_114765",
    x1: 0.970874,
    y1: 68.2692,
    x2: 100,
    y2: 68.2692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E53109"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCA4B"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtaRedemptionIcon);
export default __webpack_public_path__ + "static/media/CTA_redemption_icon.19a13f0c27236f37d588c63546457f46.svg";
export { ForwardRef as ReactComponent };